import { createFileRoute } from '@tanstack/react-router'
import { ResetCodeForm } from '@/features/auth/reset-code-form'

/** Public route for a reset code handed over by HR. */
export const Route = createFileRoute('/reset-code')({ component: ResetCodeForm })
